'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

var React = require('react');
require('./LockedUserMessage.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var LockedUserMessage = function () { return (React__default['default'].createElement("div", { className: 'locked__user--container' },
    React__default['default'].createElement("img", { src: "https://storage.googleapis.com/cdn.lifepal.tech/design-system/icon-alert-red.svg", className: 'icon' }),
    React__default['default'].createElement("div", null,
        React__default['default'].createElement("p", null,
            React__default['default'].createElement("b", null, "Tidak ditemukan akun aktif dengan Email / No. telp yang dimasukkan"),
            React__default['default'].createElement("br", null)),
        React__default['default'].createElement("p", { className: 'top-5p' }, "Cek kembali Email/No. telp yang digunakan. Apabila membutuhkan bantuan, silakan kirim email ke helpdesk@lifepal.co.id")))); };

module.exports = LockedUserMessage;
//# sourceMappingURL=index.js.map
